module.exports = __webpack_public_path__ + "img/1.83148a0d.jpg";